module.exports = __webpack_public_path__ + "static/media/best-platform-img.9eec0e30.png";